import { Component, Input, OnChanges } from '@angular/core';
import qrcode from 'qrcode-generator';

/*
  Renders a QR code fully offline (no network, CSP friendly): the library
  outputs a GIF data url consumed by a plain <img>, which goes through the
  default Angular sanitizer (no bypassSecurityTrust needed).
*/
@Component({
  selector: 'app-qr-code',
  standalone: true,
  templateUrl: './qr-code.component.html',
})
export class QrCodeComponent implements OnChanges {
  @Input({ required: true }) data!: string;
  @Input() sizeInPx = 180;

  dataUrl: string | null = null;

  ngOnChanges(): void {
    if (!this.data) {
      this.dataUrl = null;
      return;
    }

    const typeNumberAutoDetect = 0;
    const qr = qrcode(typeNumberAutoDetect, 'M');
    qr.addData(this.data);
    qr.make();

    const cellSizeInPx = 4;
    const quietZoneInCells = 8;
    this.dataUrl = qr.createDataURL(cellSizeInPx, quietZoneInCells);
  }
}
